import {
    createObjectField,
    createPrimitiveField,
    type InferFieldValue,
    literal,
    type ValidationError,
} from '@adv-frontend/form-kit';
import { type ServiceType } from '@/shared/api/order';

export const fieldPickupAddress = createObjectField({
    fields: {
        pickupPointId: createPrimitiveField({ defaultValue: '' }),
        serviceType: createPrimitiveField({ defaultValue: literal<ServiceType | null>(null) }),
        address: createPrimitiveField({ defaultValue: '' }),
        locality: createPrimitiveField({ defaultValue: '' }),
    },
    validators: (createValidators) =>
        createValidators<ValidationError<'REQUIRED_DELIVERY_ADDRESS' | 'UNSUPPORTED_ADDRESS'>>({}),
});

export type PickupAddressFieldValue = InferFieldValue<typeof fieldPickupAddress>;
